import { render, staticRenderFns } from "./AnswerDetail.vue?vue&type=template&id=4cd29801&scoped=true"
import script from "./AnswerDetail.vue?vue&type=script&lang=js"
export * from "./AnswerDetail.vue?vue&type=script&lang=js"
import style0 from "./AnswerDetail.vue?vue&type=style&index=0&id=4cd29801&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd29801",
  null
  
)

export default component.exports